import React from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';

function stripDelimiters(text) {
    const trimmed = (text || '').trim();
    if (trimmed.startsWith('$$') && trimmed.endsWith('$$')) {
        return trimmed.slice(2, -2).trim();
    }
    if (trimmed.startsWith('$') && trimmed.endsWith('$') && trimmed.length > 2) {
        return trimmed.slice(1, -1).trim();
    }
    return trimmed;
}

function renderLatex(latex, displayMode) {
    try {
        return katex.renderToString(latex, {
            displayMode,
            throwOnError: false,
            strict: 'ignore',
            trust: true,
        });
    } catch {
        return null;
    }
}

function MathSpan({ latex, display }) {
    const html = renderLatex(latex, display);
    if (!html) {
        return (
            <code style={{ color: '#ef4743', fontSize: '0.85rem', whiteSpace: 'pre-wrap' }}>
                {latex}
            </code>
        );
    }
    return (
        <span
            className={display ? 'math-display' : 'math-inline'}
            dangerouslySetInnerHTML={{ __html: html }}
            style={{ color: '#fff' }}
        />
    );
}

// Renders plain text mixed with $...$ inline and $$...$$ block math segments.
export default function MathText({ text, display = false, sx }) {
    if (!text) return null;

    if (display) {
        return (
            <span style={sx}>
                <MathSpan latex={stripDelimiters(text)} display />
            </span>
        );
    }

    const parts = text.split(/(\$\$[\s\S]+?\$\$|\$[^$\n]+?\$)/g).filter((p) => p.length > 0);

    return (
        <span style={sx}>
            {parts.map((part, idx) => {
                if (part.startsWith('$$') && part.endsWith('$$')) {
                    return <MathSpan key={idx} latex={stripDelimiters(part)} display />;
                }
                if (part.startsWith('$') && part.endsWith('$')) {
                    return <MathSpan key={idx} latex={stripDelimiters(part)} display={false} />;
                }
                return <span key={idx}>{part}</span>;
            })}
        </span>
    );
}
